import { render, staticRenderFns } from "./forgot_pass-userdata.vue?vue&type=template&id=3aed24f6"
import script from "./forgot_pass-userdata.vue?vue&type=script&lang=js"
export * from "./forgot_pass-userdata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports